import { render } from "./Wallet.vue?vue&type=template&id=184eb151"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"
script.render = render

export default script